import { render, staticRenderFns } from "./NumberofStarsRating.vue?vue&type=template&id=dffff4a2"
import script from "./NumberofStarsRating.vue?vue&type=script&lang=js"
export * from "./NumberofStarsRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports